import React, { memo, forwardRef } from "react";
const SvgCloseinterval = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M5.753 26.74h-2.7C2.351 26.74 2 26.389 2 25.687V5.817c0-.702.351-1.053 1.053-1.053h2.7c.54 0 .81.243.81.729s-.27.729-.81.729H3.782v19.06h1.971c.54 0 .81.243.81.729s-.27.729-.81.729zM17.736 21.097l-1.54 4.698c-.161.468-.44.702-.836.702a.935.935 0 01-.648-.243.72.72 0 01-.27-.594c0-.144.027-.306.08-.486l1.432-4.617c.144-.522.45-.783.918-.783.27 0 .495.081.675.243.18.162.27.378.27.648 0 .09-.027.234-.081.432zM29.386 26.74h-2.7c-.54 0-.81-.243-.81-.729s.27-.729.81-.729h1.971V6.222h-1.971c-.54 0-.81-.243-.81-.729s.27-.729.81-.729h2.7c.702 0 1.053.351 1.053 1.053v19.87c0 .702-.351 1.053-1.053 1.053z"
      />
    </svg>
  );
});
SvgCloseinterval.displayName = "SvgCloseinterval";
const MemoForwardRef = memo(SvgCloseinterval);
export default MemoForwardRef;
